var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17429 0.111792L5.38466 4.43104C5.45861 4.50691 5.5 4.60866 5.5 4.71461C5.5 4.82055 5.45861 4.9223 5.38466 4.99817L1.17429 9.31904C1.13984 9.35442 1.09866 9.38254 1.05317 9.40174C1.00767 9.42094 0.958795 9.43083 0.909416 9.43083C0.860037 9.43083 0.811158 9.42094 0.765666 9.40174C0.720172 9.38254 0.678988 9.35442 0.644541 9.31904C0.573673 9.24649 0.533998 9.14909 0.533998 9.04767C0.533998 8.94625 0.573673 8.84885 0.644541 8.77629L4.60385 4.71461L0.644541 0.653729C0.573915 0.581212 0.534394 0.483986 0.534394 0.382761C0.534394 0.281535 0.573915 0.184309 0.644541 0.111792C0.678988 0.076413 0.720172 0.0482932 0.765666 0.0290927C0.811158 0.00989219 0.860037 0 0.909416 0C0.958795 0 1.00767 0.00989219 1.05317 0.0290927C1.09866 0.0482932 1.13984 0.076413 1.17429 0.111792Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.57eb3555e4a8385b12e0d2a216bd30dd.svg";
export { ForwardRef as ReactComponent };